module.exports = __webpack_public_path__ + "img/1.02f8b5c2.png";